import EnterpriseComponent from "../EnterpriseComponent";
import MemoryContext from "../../../util/MemoryContext";

class SortEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        this.fetchEnterpriseComponentSuccess(MemoryContext.components[`EnlilSort-${this.getName()}`], page, pageSize);
    };
}

export default SortEnterpriseComponent;